module.exports = __webpack_public_path__ + "static/media/cercuri.cba4218c.png";